import { OrganigramComponent } from './../organigram-component';
import { RootNode } from './../layout/root-node';
import { VisualNode } from './visual-node';
import { LayerManager } from './layer-manager';

export class OperationsNode extends VisualNode {
    protected svgCircle: any;
    public layoutNode: RootNode;
    public zIndex: number = LayerManager.zIndexRootNode;

    constructor(private organigram: OrganigramComponent) {
        super(new RootNode());
    }

    protected initdraw() {
        this.svgCircle = this.organigram.snap.circle(
            this.layoutNode.pixelX,
            this.layoutNode.pixelY,
            this.layoutNode.pixelR
        );
        this.redraw();
    }

    protected redraw() {
        this.svgCircle.attr({
            fill: 'rgba(255,255,255,1)',
            stroke: 'rgba(0,0,0,0.2)'
        });

        this.svgCircle.attr({
            cx: this.layoutNode.pixelX,
            cy: this.layoutNode.pixelY,
            r: this.layoutNode.pixelR
        });
    }

    public refresh() {
        this.layoutNode.calculateLayout(this.organigram.organigramSize);
    }

    protected handleHover() {}

    protected handleOut() {}
}
